module.exports = __webpack_public_path__ + "img/grip.62e84655.svg";